import React from 'react';
import { Download, ChevronRight } from 'lucide-react';
interface DocumentViewerProps {
  title: string;
  fileUrl: string;
  onComplete?: () => void;
}
const DocumentViewer: React.FC<DocumentViewerProps> = ({
  title,
  fileUrl,
  onComplete
}) => {
  // Convert Google Docs URL to embed URL if needed
  const getEmbedUrl = (url: string) => {
    // Handle Google Docs URLs
    if (url.includes('docs.google.com/document')) {
      return url.replace('/edit', '/preview');
    }
    // Handle Google Drive URLs
    if (url.includes('drive.google.com/file')) {
      const fileId = url.match(/\/d\/(.*?)\//);
      if (fileId && fileId[1]) {
        return `https://drive.google.com/file/d/${fileId[1]}/preview`;
      }
    }
    return url;
  };
  const embedUrl = getEmbedUrl(fileUrl);
  return <div className="space-y-4" data-id="element-134">
      <div className="border rounded-lg overflow-hidden bg-white" data-id="element-135">
        <div className="p-3 bg-gray-50 border-b flex justify-between items-center" data-id="element-136">
          <h3 className="font-medium text-gray-700" data-id="element-137">{title}</h3>
          <a href={fileUrl} target="_blank" rel="noopener noreferrer" className="flex items-center text-blue-600 hover:text-blue-800 transition-colors" data-id="element-138">
            <Download className="mr-1 h-4 w-4" data-id="element-139" />
            <span data-id="element-140">Download</span>
          </a>
        </div>
        <iframe src={embedUrl} width="100%" height="600px" className="border-0" title={title} allow="autoplay" data-id="element-141"></iframe>
      </div>
      {onComplete && <button onClick={onComplete} className="flex items-center justify-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors w-full" data-id="element-142">
          Mark as Complete
          <ChevronRight size={16} className="ml-1" data-id="element-143" />
        </button>}
    </div>;
};
export default DocumentViewer;